import { cookieDomain } from '../utils/domain';
import { getAppConfigMap } from './appConfig';

export interface PortalConfig {
  cookieDomain?: string;
  loginUrl: string;
  homeUrl: string;
}
const basic = {
  cookieDomain: cookieDomain,
  loginUrl: `${window.location.origin}/login`,
};
const dev: PortalConfig = {
  ...basic,
  homeUrl: `${basic.loginUrl}?ref=${getAppConfigMap().flow360.redirectUrl}`,
};
const uat: PortalConfig = {
  ...basic,
  homeUrl: 'https://www.simulation.cloud',
};
const pentest: PortalConfig = {
  ...basic,
  homeUrl: 'https://www.simulation.cloud',
};
const prod: PortalConfig = {
  ...basic,
  homeUrl: 'https://www.simulation.cloud',
};
const cn: PortalConfig = {
  ...basic,
  homeUrl: `${basic.loginUrl}?ref=${getAppConfigMap().flow360.redirectUrl}`,
};
export function getPortalConfig(): PortalConfig {
  const BUILD_ENV = process.env.REACT_APP_BUILD_ENV;
  if (BUILD_ENV === 'prod') {
    return prod;
  } else if (BUILD_ENV === 'uat') {
    return uat;
  } else if (BUILD_ENV === 'pentest') {
    return pentest;
  } else if (BUILD_ENV === 'cn') {
    return cn;
  }
  return dev;
}

export default getPortalConfig();
